import { ALLOWED_PRODUCT_DOCUMENT_TYPES, IMAGE_PRIORITY, ProductImages } from '@vi-succ/products-domain';
import { ProductDetailDocument } from '../entity';

export class ProductImageFactory {
  constructor(private baseUrl: string) {}

  build(docs: ProductDetailDocument[]): ProductImages {
    return {
      smallUrl: this.getSmallImage(docs),
      mediumUrl: this.getMediumImage(docs),
      largeUrl: this.getLargeImage(docs),
    };
  }

  getSmallImage(docs: ProductDetailDocument[]): string[] | null {
    return this.getImage(docs, 3);
  }

  getMediumImage(docs: ProductDetailDocument[]): string[] | null {
    return this.getImage(docs, 3);
  }

  getImage(docs: ProductDetailDocument[], priorityIndex = 0): string[] | null {
    return this.getImageByDoc(docs, priorityIndex);
  }

  getImageByDoc(result: ProductDetailDocument[], priorityIndex = 0): string[] | null {
    if (priorityIndex > IMAGE_PRIORITY.length - 1) {
      return null;
    }
    const images = this.getImageDoc(result, priorityIndex)?.map((doc) => `${this.baseUrl}/${doc.fileName}`);

    return images ? images : null;
  }

  getImageDoc(result: ProductDetailDocument[], priorityIndex = 0): ProductDetailDocument[] | null {
    if (priorityIndex > IMAGE_PRIORITY.length - 1) {
      return null;
    }

    const images = (result ?? [])
      .filter((doc) => this.isAllowedImageType(doc))
      .filter((document) => {
        return document.documentPart === IMAGE_PRIORITY[priorityIndex];
      });

    if (images.length > 0) {
      return images;
    } else {
      return this.getImageDoc(result, priorityIndex + 1);
    }
  }

  private isAllowedImageType(doc: ProductDetailDocument): boolean {
    return !doc.fileName.toLowerCase().endsWith('txt') && ALLOWED_PRODUCT_DOCUMENT_TYPES.includes(doc.documentType);
  }

  private getLargeImage(docs: ProductDetailDocument[]) {
    return this.getImage(docs, 0);
  }
}
